import { render, staticRenderFns } from "./practiceList.vue?vue&type=template&id=bcd5f03a&scoped=true"
import script from "./practiceList.vue?vue&type=script&lang=js"
export * from "./practiceList.vue?vue&type=script&lang=js"
import style0 from "./practiceList.vue?vue&type=style&index=0&id=bcd5f03a&lang=scss"
import style1 from "./practiceList.vue?vue&type=style&index=1&id=bcd5f03a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd5f03a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcd5f03a')) {
      api.createRecord('bcd5f03a', component.options)
    } else {
      api.reload('bcd5f03a', component.options)
    }
    module.hot.accept("./practiceList.vue?vue&type=template&id=bcd5f03a&scoped=true", function () {
      api.rerender('bcd5f03a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/realTest/practiceList.vue"
export default component.exports